// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1SW2w","content":"styles_content__3saNG","tableWrap":"styles_tableWrap__Rgs_W"};